import {
  Component,
  Output,
  EventEmitter,
  ViewEncapsulation,
  signal,
  inject,
} from '@angular/core';
import { AppSettings } from 'src/app/config';
import { CoreService } from 'src/app/services/core.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslateModule } from '@ngx-translate/core';

/** Valores string en toggles: `mat-button-toggle` falla con `false` booleano. */
type YesNo = 'yes' | 'no';

@Component({
  selector: 'app-customizer',
  imports: [
    TablerIconsModule,
    MaterialModule,
    FormsModule,
    NgScrollbarModule,
    TranslateModule,
  ],
  templateUrl: './customizer.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class CustomizerComponent {
  private readonly settings = inject(CoreService);

  readonly options = this.settings.options;

  @Output() optionsChange = new EventEmitter<AppSettings>();
  hideSingleSelectionIndicator = signal(true);

  asYesNo(value: boolean): YesNo {
    return value ? 'yes' : 'no';
  }

  apply(partial: Partial<AppSettings>): void {
    const next = this.settings.setOptions(partial);
    this.optionsChange.emit(next);
  }

  setTheme(theme: string): void {
    this.apply({ theme });
  }

  setDir(dir: 'ltr' | 'rtl'): void {
    // Al voltear dir, Material cierra el drawer; forzar abierto en escritorio.
    this.apply({ dir, sidenavOpened: true });
  }

  setSidebarCollapsed(value: YesNo): void {
    // Compacta = solo rail; Completa = rail + panel de módulo.
    this.apply({ sidenavCollapsed: value === 'yes', sidenavOpened: true });
  }

  setHorizontal(value: YesNo): void {
    const horizontal = value === 'yes';
    this.apply({
      horizontal,
      navPos: horizontal ? 'top' : 'side',
    });
  }

  setCardBorder(value: YesNo): void {
    this.apply({ cardBorder: value === 'yes' });
  }

  setBoxed(value: YesNo): void {
    this.apply({ boxed: value === 'yes' });
  }
}
